var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContractRestore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 8.94C19.9896 8.84813 19.9695 8.75763 19.94 8.67V8.58C19.8919 8.47718 19.8278 8.38266 19.75 8.3V8.3L13.75 2.3V2.3C13.6673 2.22222 13.5728 2.15808 13.47 2.11C13.4401 2.10576 13.4098 2.10576 13.38 2.11C13.2784 2.05174 13.1662 2.01434 13.05 2H7C5.34315 2 4 3.34315 4 5V19C4 20.6569 5.34315 22 7 22H17C18.6569 22 20 20.6569 20 19V9C20 9 20 9 20 8.94ZM14 5.40997L16.59 7.99997H15C14.4477 7.99997 14 7.55225 14 6.99997V5.40997ZM18 19C18 19.5523 17.5523 20 17 20H7.00002C6.44773 20 6.00002 19.5523 6.00002 19V4.99997C6.00002 4.44768 6.44773 3.99997 7.00002 3.99997H12V6.99997C12 8.65682 13.3432 9.99997 15 9.99997H18V19ZM14.29 12.29L11 15.59L9.71002 14.29C9.31789 13.8979 8.68214 13.8979 8.29002 14.29C7.89789 14.6821 7.89789 15.3179 8.29002 15.71L10.29 17.71C10.4778 17.8993 10.7334 18.0058 11 18.0058C11.2667 18.0058 11.5222 17.8993 11.71 17.71L15.71 13.71C16.1021 13.3179 16.1021 12.6821 15.71 12.29C15.3179 11.8978 14.6821 11.8978 14.29 12.29V12.29Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractRestore);
export default __webpack_public_path__ + "static/media/contract_restore.b9b587e0cabd887f5f9cf8f5a9d9a021.svg";
export { ForwardRef as ReactComponent };